import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton
} from '@mui/material';
import { useRef, useState } from 'react';
import { AppContext } from '../../../context/AppContext';
import BakeasyTextField from '../../../components/textfields/BakeasyTextField';
import { t } from 'i18next';
import { useAppDispatch } from '../../../redux_store/reduxStore';
import { addSubCategory, modifySubCategory } from '../../../redux_store/slices/subCategorySlice';
import {
  BakeasyButtonClose,
  BakeasyButtonCreate,
  BakeasyButtonUpdate
} from '../../../components/buttons/BakeasyButton';
import * as Dropdown from '../../../components/dropdowns/BakeasySelect';
import { Close } from '@mui/icons-material';
import { validateField } from '../../../utils/ValidationUtils';
import * as Regex from '../../../constants/Regex';

export const AddEditSubCategory = (props: any) => {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);
  const formRef = useRef<HTMLDivElement>(null);

  const [name, setName] = useState<any>('');
  const [description, setDescription] = useState<any>('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [subCategoryId, setSubCategoryId] = useState<string>('');
  const [categoryId, setCategoryId] = useState<string>('');

  function handleClose() {
    myContext.setDialog({ open: false });
    props?.onBack(categoryId);
  }

  const checkValidity = (): boolean => {
    if (!validateField(dispatch, 'SUBCATEGORY_NAME', name, formRef, Regex.name)) {
      return false;
    }
    // if (!description) {
    // 	let msg = `${t("DESCRIPTION")} ${t("IS_REQUIRED")}`;
    // 	dispatch(showErrorSnackbar({ message: msg }));
    // 	return false;
    // }
    if (!validateField(dispatch, 'STATUS', selectedStatus, formRef)) {
      return false;
    }
    return true;
  };

  async function onAddSubmit() {
    if (!checkValidity()) {
      return;
    }

    let payload = {
      categoryId: categoryId,
      subCategoryName: name,
      status: selectedStatus,
      ...(description && { description: description })
    };

    await dispatch(addSubCategory(payload));
    handleClose();
  }

  async function onEditSubmit() {
    if (!checkValidity()) {
      return;
    }
    let payload = {
      id: subCategoryId,
      categoryId: categoryId,
      subCategoryName: name,
      description: description,
      status: selectedStatus
    };

    await dispatch(modifySubCategory(payload));
    handleClose();
  }

  React.useEffect(() => {
    setName(props?.params?.name);
    setDescription(props?.params?.description);
    setSelectedStatus(props?.params?.status);
    setSubCategoryId(props?.params?.subCategoryId);
    setCategoryId(props?.params?.categoryId);
  }, []);

  return (
    <div ref={formRef}>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {props?.params?.isEdit ? t('EDIT_SUB_CATEGORY') : t('ADD_SUB_CATEGORY')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent>
        <Grid item xs={12} sm={12}>
          <BakeasyTextField
            label={t('SUBCATEGORY_NAME')}
            placeHolder={t('ENTER_SUBCATEGORY_NAME')}
            type="text"
            name="name"
            value={name}
            regexPattern={Regex.name}
            onChange={(event: any) => {
              setName(event.target.value);
            }}
            required={true}
          />
        </Grid>

        <Grid item xs={12} sm={12} marginTop={1}>
          <BakeasyTextField
            label={t('DESCRIPTION')}
            placeHolder={t('ENTER_DESCRIPTION')}
            type="text"
            name="description"
            value={description}
            maxLength={500}
            multiline
            rows={4}
            onChange={(event: any) => {
              setDescription(event.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12} marginTop={1}>
          <Dropdown.Status
            label={t('STATUS')}
            placeholder={t('SELECT_STATUS')}
            size="small"
            fullWidth={true}
            value={selectedStatus}
            required={true}
            onChange={(event: any) => {
              setSelectedStatus(event.target.value);
            }}
          />
        </Grid>
      </DialogContent>

      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonClose onClick={handleClose} />

        {props?.params?.isEdit ? (
          <BakeasyButtonUpdate
            onClick={() => {
              onEditSubmit();
            }}
          />
        ) : (
          <BakeasyButtonCreate
            onClick={() => {
              onAddSubmit();
            }}
          />
        )}
      </DialogActions>
    </div>
  );
};
